// NATIVE

// INSTALLED

// CUSTOM
import { storageGetAssignedUserPermissions } from '../commons/utils';

export const useAssignedUserPermissions = () => {
  const initCheckAssignedUserPermissions = async () => {
    const permissions: any = await storageGetAssignedUserPermissions();
    return permissions;
  };

  return [initCheckAssignedUserPermissions];
};
